import { useRouter } from 'next/router';
import React from 'react';

import { ROUTES } from '@common/constant/routeConstant';
import { ACADEMIC_TYPE } from '@common/type/CourseTypes';
import { Box, BoxProps, Button, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import PurchaseButton from '../purchaseButton';
import PurchaseRemark from '../purchaseRemark';

import EnrolledBox from './enrolledBox';

import { useBreakpointV2 } from '@helpers/use';
import { AcademicCourseEnrollmentStatus, CourseDetailEntity } from '@redux/course/type/courseDetailType';

type PurchaseUnavailableProps = {
  sx?: BoxProps['sx'];
  idName: string;
  enrollmentStatus: AcademicCourseEnrollmentStatus;
  examExpiredAt?: Date;
  price: CourseDetailEntity['price'];
  isUnPurchase?: boolean;
  isEnrolled?: boolean;
};

const PurchaseUnavailable = ({
  sx,
  idName,
  enrollmentStatus,
  examExpiredAt,
  price,
  isEnrolled,
  isUnPurchase,
}: PurchaseUnavailableProps) => {
  const router = useRouter();
  const { t } = useTranslation('store_course');
  const { isMobile } = useBreakpointV2();

  const handleClickContinueLearning = () => {
    router.push(ROUTES.COURSE.LEARNING(idName));
  };

  return (
    <Box sx={{ ...sx }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '16px', md: '24px' } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: { lg: '190px', md: '156px', xs: 'unset' },
            gap: { xs: '16px', md: '24px', lg: '16px' },
          }}
        >
          {isEnrolled && <EnrolledBox />}
          {isUnPurchase && (
            <Box
              sx={{ display: 'grid', gap: '16px', gridTemplateAreas: { xs: '"credit" "audit"', md: '"audit credit"' } }}
            >
              <PurchaseButton idName={idName} enrollmentStatus={enrollmentStatus} price={price} disabled />
              <PurchaseButton
                idName={idName}
                purchaseType={ACADEMIC_TYPE.CREDIT}
                enrollmentStatus={enrollmentStatus}
                price={price}
                disabled
              />
            </Box>
          )}
          <PurchaseRemark examExpiredAt={examExpiredAt} enrollmentStatus={enrollmentStatus} />
        </Box>
        {isEnrolled && (
          <Button
            sx={{ height: { md: '60px', xs: '40px', padding: '8px 16px' } }}
            variant="contained"
            color="secondary"
            onClick={handleClickContinueLearning}
            fullWidth
          >
            <Typography variant={isMobile ? 'button' : 'h4'}>
              {t('course_detail.header_banner.purchase.enrolled.button.text')}
            </Typography>
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default PurchaseUnavailable;
